import {
  Box,
  Container,
  Grid,
  Typography,
  styled,
} from "@mui/material";

function LoadingPaymentDetails({ depositVerify }) {

  return (
    <Container maxWidth="sm">
      <Grid container>
        <Grid item xs="12">
          <BoxStyle>
            <Grid container justifyContent="center" spacing={2}>
              <Grid item xs="12">
                <Typography color="text.main" variant="h4" dir="rtl">
                  پرداخت شما در حال تایید بانکی میباشد. لطفا صبر کنید
                </Typography>
              </Grid>
            </Grid>
          </BoxStyle>
        </Grid>
      </Grid>
    </Container>
  );
}

const BoxStyle = styled(Box)(({ theme }) => ({
  background: theme.palette.background.primaryGradient,
  padding: theme.spacing(2),
  textAlign: "center",
  borderRadius: "8px",
}));

export default LoadingPaymentDetails;
